function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 1.006c9.58 0 21-.76 21 14.994 0 15.755-11.42 14.994-21 14.994S1 31.754 1 16C1 .245 12.42 1.006 22 1.006z",
  fill: "#FBB14F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.473 22.442c.18.18.378.252.576.252.594 0 1.17-.612 1.17-1.188a.849.849 0 00-.234-.576l-3.312-3.312 3.312-3.294a.804.804 0 00.252-.594c0-.576-.612-1.188-1.206-1.188a.788.788 0 00-.576.234l-3.312 3.312-3.312-3.312a.788.788 0 00-.576-.234c-.594 0-1.206.612-1.206 1.188 0 .216.072.414.252.594l3.312 3.294-3.312 3.312a.849.849 0 00-.234.576c0 .576.576 1.188 1.17 1.188a.795.795 0 00.576-.252l3.33-3.294 3.33 3.294zM31.81 23c.666 0 .99-.594.99-1.206 0-.594-.324-1.206-.99-1.206h-6.174c.288-1.152 1.854-2.106 3.438-3.024 1.782-.99 3.366-2.214 3.456-4.446v-.198c0-2.358-1.494-4.374-4.518-4.374-2.772 0-4.518 1.674-4.788 4.068v.108c0 .72.648 1.134 1.26 1.134.522 0 1.044-.306 1.116-.918.144-1.314.99-2.034 2.304-2.034 1.404 0 2.124.918 2.124 1.944 0 .09 0 .162-.018.252-.09 1.08-.954 1.872-2.124 2.556-1.512.864-3.528 1.98-4.482 3.744-.36.684-.54 1.332-.54 1.89 0 1.008.594 1.71 1.746 1.71h7.2z",
  fill: "#fff"
});

var SvgPointDouble = function SvgPointDouble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPointDouble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/point-double.309e82b8.svg";
export { ForwardRef as ReactComponent };